const inventorySearch = {
  path: "/inventory/search",
  name: "inventorySearch",
  component: () => import(/* webpackChunkName: "inventorySearch" */ `@/components/inventory/InventorySearch.vue`),
  meta: { authorize: ['Administrator', 'Manager', 'Technician'], requiresAuth: true }
};

export default inventorySearch;
    